<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar logo="/img/brand/brand.svg" background-color="blue">
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{
            name: 'Companies',
            path: '/companies',
            icon: 'ni ni-shop text-primary',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'New Company',
            path: '/companies/create',
            icon: 'ni ni-fat-add text-success',
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="account"
          :link="{
            name: account.name,
            icon: 'ni ni-briefcase-24 text-info',
            classes: 'ellipsis',
          }"
        >
          <sidebar-item
            :link="{
              name: 'Manage account',
              path: '/account',
              icon: 'ni ni-settings text-primary',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Switch account',
              path: '/select-account',
              icon: 'fa fa-random text-primary',
            }"
          ></sidebar-item>
        </sidebar-item>
      </template>

      <template slot="links-after">
        <hr class="my-3" />
        <!-- <h6 class="navbar-heading p-0 text-muted">Documentation</h6> -->

        <b-nav class="navbar-nav mb-md-3">
          <b-nav-item href="mailto:support@adminhero.co">
            <i class="ni ni-spaceship"></i>
            <b-nav-text class="p-0">Support</b-nav-text>
          </b-nav-item>
          <b-nav-item href="https://adminhero.co">
            <i class="ni ni-palette"></i>
            <b-nav-text class="p-0">About</b-nav-text>
          </b-nav-item>
        </b-nav>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./Navbar.vue";
import ContentFooter from "./Footer.vue";
import DashboardContent from "../Layout/Content.vue";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
  },
  computed: {
    account: function () {
      return this.$store.state.account;
    },
  },
  methods: {
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      let isLinux = navigator.platform.startsWith("Linux");
      if (isWindows || isLinux) {
        // on windows OS or Linux, activate the perfectScrollbar function
        initScrollbar("scrollbar-inner");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
  },
};
</script>
